import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Loading } from '@app/shared/ui/organisms/Common';
import { NotFound, TopBar } from '@app/shared/ui/molecules/Common';
import { CloseButton, ScrollArea } from '@app/shared/ui/atoms/Common';
import { StoneAbilitiesContent } from '@app/shared/ui/organisms/StoneAbilities';
import { useGetEnergyStoneInfo } from '@app/shared/hooks/useGetEnergyStoneInfo';
import { useDisplayError } from '@app/shared/hooks/useDisplayError';
import { usePreloadImages } from '@app/shared/hooks/usePreloadImages';
import { STONE_ABILITIES_PRELOAD_IMAGES } from '@app/assets';
import { Page } from '@app/routes';

export default function StoneAbilitiesPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { energyStones, isStonesLoading, isStonesError } = useGetEnergyStoneInfo();
  const isImagesLoading = usePreloadImages(STONE_ABILITIES_PRELOAD_IMAGES);

  const failedToLoadStonesMsg = t('errors.failed_to_load_stones');
  useDisplayError(isStonesError, failedToLoadStonesMsg);

  if (isStonesLoading || isImagesLoading) {
    return <Loading />;
  }

  return (
    <ScrollArea className="relative">
      <TopBar translationKey="stone_abilities.title" />
      <CloseButton className="absolute right-0" onClick={() => navigate(Page.HOME)} />
      {energyStones.length > 0 ? (
        <StoneAbilitiesContent energyStones={energyStones} />
      ) : (
        <NotFound containerClassName="p-3" message={failedToLoadStonesMsg} withLightBlueBg />
      )}
    </ScrollArea>
  );
}
